<div class="scrollWrapper kgr-scrollable">
  <div class="kgr-region kgr-region--big kgr-text kgr-text--centered">
    <a routerLink="/">
      @if (organization$ | async; as organization) {
        @if (!staticLogo && organization.hasLogo) {
          <img [kgrApiImageSrc]="organization.logoApiUrl" alt="Logo" i18n-alt class="logo" />
        } @else {
          <img class="logo" [src]="'./assets/client/' + clientLogoFileName" alt="Logo" i18n-alt />
        }
      } @else {
        <img class="logo" [src]="'./assets/client/' + clientLogoFileName" alt="Logo" i18n-alt />
      }
    </a>
  </div>

  <div class="kgr-region">
    <nav class="kgr-verticalMenu">
      @for (clientSystemLink of clientSystemLinks$ | async; track clientSystemLink) {
        <kgr-client-system-link [clientSystemLink]="clientSystemLink"></kgr-client-system-link>
      }

      @if (isScreenMediumAndUp$ | async) {
        <a routerLink="/teams" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
          <span class="kgr-verticalMenu__itemIcon">
            <svg kgrIcon="users" [small]="true"></svg>
          </span>
          <span class="kgr-verticalMenu__itemLabel" i18n>Teams</span>
        </a>
        <a routerLink="/news" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
          <span class="kgr-verticalMenu__itemIcon">
            <svg kgrIcon="calendar" [small]="true"></svg>
          </span>
          <span class="kgr-verticalMenu__itemLabel" i18n>News</span>
        </a>
        <a *kgrIfModuleEnabled="'Chat'" routerLink="/chats" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
          <span class="kgr-verticalMenu__itemIcon">
            <svg kgrIcon="chat" [small]="true"></svg>
          </span>
          <span class="kgr-verticalMenu__itemLabel" i18n>Chats</span>
        </a>
        <a *kgrIfModuleEnabled="'offering'" routerLink="/offerings" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
          <span class="kgr-verticalMenu__itemIcon">
            <svg kgrIcon="local-offer" [small]="true"></svg>
          </span>
          <span class="kgr-verticalMenu__itemLabel" i18n>Angebot</span>
        </a>
      }

      <ng-container *kgrIfModuleEnabled="'memberRegistry'">
        <a routerLink="/members" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
          <span class="kgr-verticalMenu__itemIcon">
            <svg kgrIcon="import-contacts" [small]="true"></svg>
          </span>
          <span class="kgr-verticalMenu__itemLabel" i18n>Mitgliederverzeichnis</span>
        </a>
      </ng-container>

      <a routerLink="/files" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
        <span class="kgr-verticalMenu__itemIcon">
          <svg kgrIcon="folder-shared" [small]="true"></svg>
        </span>
        <span class="kgr-verticalMenu__itemLabel" i18n>Dokumente</span>
      </a>

      <a routerLink="/organization/contact" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
        <span class="kgr-verticalMenu__itemIcon">
          <svg kgrIcon="comment" [small]="true"></svg>
        </span>
        <span class="kgr-verticalMenu__itemLabel" i18n>Kontakt</span>
      </a>

      <a [href]="privacyUrl" target="_blank" rel="noopener" class="kgr-verticalMenu__item is-level-1">
        <span class="kgr-verticalMenu__itemIcon">
          <svg kgrIcon="security" [small]="true"></svg>
        </span>
        <span class="kgr-verticalMenu__itemLabel" i18n>Datenschutz</span>
      </a>
    </nav>
  </div>
</div>
